import { useCallback, useRef, useSyncExternalStore } from 'react';
import { shallow } from 'zustand/shallow';
import { useEntityStore } from '@/lib/sync/entity-store';
import type { RecordingMeta } from '@/lib/recordings/types/types';

const NONE: readonly RecordingMeta[] = [];

export function useFinishedRecordings(entityId: string, enabled: boolean): readonly RecordingMeta[] {
  const last = useRef(NONE);
  const subscribe = useCallback(
    (onChange: () => void) => (enabled ? useEntityStore.subscribe(onChange) : () => {}),
    [enabled],
  );
  const getSnapshot = () => {
    if (!enabled) return NONE;
    const next = Array.from(useEntityStore.getState().recordings.values()).filter(
      (r) => r != null && r.entityId === entityId && r.status === 'complete',
    );
    if (!shallow(next, last.current)) last.current = next;
    return last.current;
  };
  return useSyncExternalStore(subscribe, getSnapshot);
}
